import React from 'react'
import * as PropTypes from 'prop-types'
import { Form, Input } from 'antd'
import { useTranslation } from 'react-i18next'

const EmailField = ({ required = false, loading = false, autoFocus = false, disabled, formName }) => {
  const { t } = useTranslation()

  return (
    <Form.Item
      label={t('common.email')}
      name="email"
      rules={[
        { required: required || false, message: t('common.emailRequired') },
        { max: 200, message: t('common.emailTooLong') },
        {
          type: 'email',
          message: t('common.emailNotValid')
        }
      ]}
    >
      <Input
        data-testid={`${formName || 'emailField'}-email`}
        disabled={loading || disabled}
        autoComplete="email"
        autoFocus={autoFocus}
      />
    </Form.Item>
  )
}

EmailField.propTypes = {
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool
}

export default EmailField
